import {FC} from 'react'
import {Form} from 'react-bootstrap'
import {Resource} from '../../resources/core/_models'

type Props = {
  resourceDetail: Resource
}

const ResourcesDetailView: FC<Props> = ({resourceDetail}) => {
  const renderValue = (value?: string | number | boolean | null) => {
    if (value === null || value === undefined || value === '') return '-'
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    return String(value)
  }

  return (
    <div className='detail-resource'>
      {/* English Content */}
      <h3>English Content</h3>
      <div className='row mb-4'>
        <div className='col-md-12 mb-3'>
          <Form.Label>Title</Form.Label>
          <div className='data-value'>{renderValue(resourceDetail.title)}</div>
        </div>
        <div className='col-md-12 mb-3'>
          <Form.Label>Short Description</Form.Label>
          <div
            className='data-value'
            dangerouslySetInnerHTML={{__html: renderValue(resourceDetail.short_desc)}}
          />
        </div>
      </div>

      <hr />

      {/* French Content */}
      <h3>French Content</h3>
      <div className='row mb-4'>
        <div className='col-md-12 mb-3'>
          <Form.Label>Title (FR)</Form.Label>
          <div className='data-value'>{renderValue(resourceDetail.title_fr)}</div>
        </div>
        <div className='col-md-12 mb-3'>
          <Form.Label>Short Description (FR)</Form.Label>
          <div
            className='data-value'
            dangerouslySetInnerHTML={{__html: renderValue(resourceDetail.short_desc_fr)}}
          />
        </div>
      </div>

      <hr />

      {/* Media & Links */}
      <h3>Media & Links</h3>
      <div className='row mb-4'>
        <div className='col-md-12 mb-3'>
          <Form.Label>Image</Form.Label>
          <div className='data-value'>
            {resourceDetail.image_url ? (
              <div className='d-flex flex-column gap-2'>
                <img
                  src={resourceDetail.image_url}
                  alt='Resource cover'
                  style={{
                    maxWidth: '320px',
                    borderRadius: '6px',
                    border: '1px solid #dee2e6',
                  }}
                  onError={(e) => {
                    ;(e.target as HTMLImageElement).style.display = 'none'
                  }}
                />
                <a
                  href={resourceDetail.image_url}
                  target='_blank'
                  rel='noreferrer'
                  className='text-break'
                >
                  {resourceDetail.image_url}
                </a>
              </div>
            ) : (
              '-'
            )}
          </div>
        </div>

        <div className='col-md-12 mb-3'>
          <Form.Label>Download / View URL</Form.Label>
          <div className='data-value'>
            {resourceDetail.download_url ? (
              <a
                href={resourceDetail.download_url}
                target='_blank'
                rel='noreferrer'
                className='text-break'
              >
                {resourceDetail.download_url}
              </a>
            ) : (
              '-'
            )}
          </div>
        </div>

        <div className='col-md-6 mb-3'>
          <Form.Label>Type</Form.Label>
          <div className='data-value'>
            {resourceDetail.is_video === 1 ? <span>Video</span> : <span>Document</span>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResourcesDetailView
